import axios from 'axios';

import config from '../utils/config';
import * as MapFieldActions from '../actions/mapField';
import * as AuthCreators from './auth';
import { userId$ } from '../selectors/mapField';

const URL = config().mapField;

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';

export const fetchMapField = (fieldId: number): any => {
  return (dispatch, getState): void => {
    dispatch(MapFieldActions.setMapFieldPending());
    const params = new URLSearchParams();
    params.append('field_id', `${fieldId}`);
    params.append('customer_id', userId$(getState()));

    axios({
      method: 'get',
      url: `${URL}?${params}`,
    })
      .then(response => {
        dispatch(MapFieldActions.fetchMapFieldSuccess(fieldId, response.data));
      })
      .catch(error => {
        if (error.response.status === 401) {
          dispatch(AuthCreators.fetchRefreshAuthToken(fetchMapField(fieldId)));
        } else {
          dispatch(MapFieldActions.setMapFieldError());
        }
      });
  };
};
